export const CULTURE_CHANGE_REQUEST = 'CULTURE_CHANGE_REQUEST';
export const CULTURE_CHANGE_SUCCESS = 'CULTURE_CHANGE_SUCCESS';
export const CULTURE_CHANGE_ERROR = 'CULTURE_CHANGE_ERROR';
export const CULTURE_TRANSLATIONS_REQUEST = 'CULTURE_TRANSLATIONS_REQUEST';
export const CULTURE_TRANSLATIONS_SUCCESS = 'CULTURE_TRANSLATIONS_SUCCESS';
export const CULTURE_TRANSLATIONS_ERROR = 'CULTURE_TRANSLATIONS_ERROR';
